const ALL_COMPONENTS_SECTION_ID_SUFFIX = "--all";

const INDIVIDUAL_COMPONENTS_SECTION_NAME = "Individual components";
const INDIVIDUAL_COMPONENTS_SECTION_DESCRIPTION = "All components that do not have variants are collected under this section";

export {
    ALL_COMPONENTS_SECTION_ID_SUFFIX,
    INDIVIDUAL_COMPONENTS_SECTION_NAME,
    INDIVIDUAL_COMPONENTS_SECTION_DESCRIPTION
};
